import type { ReactNode } from 'react';
import { formatDate, type FORMAT_OPTIONS } from '../../utils/format-date';

interface FormattedDateProps {
  date?: string;
  locale: string;
  token?: keyof typeof FORMAT_OPTIONS;
}

export function FormattedDate({ date, ...options }: FormattedDateProps): ReactNode {
  /**
   * Appends T00:00:00 to a date string to prevent timezone issues when using new Date()
   * @param newDate - The date string to format in YYYY-MM-DD format
   * @returns The date string with T00:00:00 appended, or the original value if null/undefined
   */
  const addTimeToDate = (newDate: string | undefined): string | Date => {
    if (!newDate) return new Date();
    // Check if the date is in YYYY-MM-DD format before appending time
    const isValidFormat = /^\d{4}-\d{2}-\d{2}$/.test(newDate);
    return isValidFormat ? `${newDate}T00:00:00` : newDate;
  };

  return date ? formatDate({ date: addTimeToDate(date), ...options }) : null;
}
